import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal-body pb-10 pt-0 px-lg-17" }
const _hoisted_2 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_create_api_key_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_create_api_key_header",
  "data-kt-scroll-wrappers": "#kt_modal_create_api_key_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row fs-5" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_14 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_18 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = { class: "mb-5 fv-row" }
const _hoisted_22 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_23 = { class: "mb-5 fv-row" }
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_27 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = {
  key: 2,
  class: "col-md-4"
}
const _hoisted_31 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { class: "modal-footer flex-center" }
const _hoisted_35 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_create_api_key_submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Form, {
      id: "kt_modal_create_api_key_form",
      class: "form",
      onSubmit: _ctx.submit,
      "validation-schema": _ctx.validationSchema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Field, {
                  name: "customer_type",
                  "data-control": "select2",
                  "data-hide-search": "true",
                  "data-placeholder": "Select a Category...",
                  class: "form-select form-select-solid border border-primary",
                  as: "select",
                  modelValue: _ctx.picked,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.picked) = $event))
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createElementVNode("option", { value: "v1" }, "V1", -1),
                    _createElementVNode("option", { value: "v2" }, "V2", -1)
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("hr", { class: "mt-2 mb-15" }, null, -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2 ms-2" }, "ICCID", -1)),
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid border border-primary",
                    rows: "3",
                    name: "icc",
                    placeholder: "ICCID",
                    modelValue: _ctx.nbiotData.icc,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nbiotData.icc) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_ErrorMessage, { name: "icc" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2 ms-2" }, "IMEI", -1)),
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid border border-primary",
                    rows: "3",
                    name: "variant_id",
                    placeholder: "Enter Imei",
                    modelValue: _ctx.nbiotData.variant_id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nbiotData.variant_id) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_ErrorMessage, { name: "variant_id" })
                    ])
                  ])
                ])
              ]),
              (_ctx.picked == 'v1')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2 ms-2" }, "Unique Random Number", -1)),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid border border-primary",
                        rows: "3",
                        name: "unique_random_number",
                        placeholder: "Describe your API",
                        modelValue: _ctx.nbiotData.unique_random_number,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nbiotData.unique_random_number) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ErrorMessage, { name: "unique_random_number" })
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.picked == 'v2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-2" }, "Product ID", -1)),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid border border-primary",
                        rows: "3",
                        name: "product_id",
                        placeholder: "Product ID",
                        modelValue: _ctx.nbiotData.product_id,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.nbiotData.product_id) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-2" }, "Product Count", -1)),
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "bg-light rounded-2 form-control form-control-solid border border-primary",
                    placeholder: "Product Count",
                    name: "product_count",
                    modelValue: _ctx.nbiotData.product_count,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.nbiotData.product_count) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              (_ctx.picked == 'v2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[16] || (_cache[16] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2 ms-2" }, "Device Serial ID", -1)),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "bg-light rounded-2 form-control form-control-solid border border-primary",
                        placeholder: "Device Serial ID",
                        name: "serial_number",
                        modelValue: _ctx.nbiotData.serial_number,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.nbiotData.serial_number) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_ErrorMessage, { name: "serial_number" })
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.picked == 'v1')
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[17] || (_cache[17] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2 ms-2" }, "Device Serial Number", -1)),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid border border-primary",
                        rows: "3",
                        name: "serial_number",
                        placeholder: "Serial Number",
                        modelValue: _ctx.nbiotData.serial_number,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.nbiotData.serial_number) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_ErrorMessage, { name: "serial_number" })
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.picked == 'v2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _cache[18] || (_cache[18] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2 ms-2" }, "Device UID", -1)),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid border border-primary",
                        rows: "3",
                        name: "unique_random_number",
                        placeholder: "Device UID",
                        modelValue: _ctx.nbiotData.unique_random_number,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.nbiotData.unique_random_number) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_ErrorMessage, { name: "unique_random_number" })
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "row" }, null, -1)),
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "row" }, [
              _createElementVNode("div", { class: "d-flex flex-column mb-5 fv-row" })
            ], -1)),
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "row" }, [
              _createElementVNode("div", { class: "col-md-4" })
            ], -1)),
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "row" }, null, -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("button", _hoisted_35, _cache[23] || (_cache[23] = [
            _createElementVNode("span", { class: "indicator-label" }, " Submit ", -1),
            _createElementVNode("span", { class: "indicator-progress" }, [
              _createTextVNode(" Please wait... "),
              _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
            ], -1)
          ]), 512)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}